import {
  Accordion,
  ButtonPrimaryCompact,
  CheckboxInput,
  Divider,
  SwitchSingle,
  TagDisplayV2,
  UI_BODY,
  UI_BODY_BOLD_SM,
  UI_BODY_SEMIBOLD,
  UI_BODY_SEMIBOLD_SM,
  UI_BODY_SM,
  UI_CAPTION,
  UI_DISPLAY,
  UI_TAG,
  getText,
  icons,
  transition,
  useHandleClickOutside,
  
  useScreenWidth,
  getBreakPoint,
  ButtonSecondaryCompact,
  UI_BODY_BOLD,
  ButtonGhostV2,
  ButtonPrimaryV2,
  ButtonSecondaryV2,
  DropdownMulti
} from "oolib";
import { DropdownSingle } from "oolib/dist/v2/components/Dropdowns/DropdownSingle";
import { TabBarStyle2 } from "oolib/dist/v2/components/TabBar";
import { Tag, TagClear } from "oolib/dist/v2/components/Tags";
import React, { useCallback, useEffect, useMemo, useRef, useState } from "react";
import styled from "styled-components";
import FilterModule from "../../discovery/FilterModule";
import { SidebarLayoutV2 } from "../../layout/SidebarLayoutV2";
import { ListingModuleAnnotationExplorer } from "./comps/ListingModuleAnnotationExplorer";
import { SearchSortPanel } from "./comps/SearchSortPanel";
import { useGetAnnotationExplorerData } from "./useGetAnnotationExplorerData";
import { getAnnoExplorerConfigsForThisTenant } from "./utils/getAnnoExplorerConfigsForThisTenant";
import { useES_CountData, useGetAnnotationsLazy, useGetDataQuery } from "../../../utils/react-query-hooks/getData";
import { wrap } from "lodash";
import { getFilterType } from "@/components/inputs/DynamicTagsInputs/FilterInput/utils/getFilterType";
import { createPortal } from "react-dom";
import { ColorCodeLightBox } from "./comps/ColorCodeLightBox";
import { addFillColorsToEachAnno } from "./utils/addFillColorsToEachAnno";
import { CustomSelectComp } from "./comps/CustomSelectComp";
import { getTenant } from "@/TENANT_CONFIGS";
import { generateColorCodeOptions } from "./utils/generateColorCodeOptions";
import { cleanFilterConfigsForColorCode } from "./utils/cleanFilterConfigsForColorCode";
import { translateColorCodeFiltersToBE, COLOR_CODE_COLORS, MAX_COLOR_CODE_COLORS } from "./utils/translateColorCodeFiltersToBE";
import { useAutoGenFilterConfigsFromTpl } from "../utils/useAutoGenFilterConfigsFromTpl";
import mixpanel from "mixpanel-browser";
import { AnnotationExplorerVizPanel } from "./comps/AnnotationExplorerVizPanel";
import { CardAnnoExplorer } from "./comps/CardAnnoExplorer";
import { useElemInView } from "@/utils/customHooks/useElemInView";

import { useHeaderHeight } from "@/CONSTANTS";

import { useGetQueryData } from "@/utils/react-query-hooks/general";
import { getAnnoMode } from "@/utils/getAnnoMode";
import { FILTER_IDS, getAnnoFilterBucketKey } from "@okf/ootils";
import { downloadCsvFile } from "@/utils/general";
import { useGetExportToCsvContent } from "@/utils/react-query-hooks/exportToCsv";
import { useDynamicLayoutHeight } from "../InsightMatrix/utils/useDynamicLayoutHeight";
import { FiltersLoader } from "./comps/FiltersLoader";
import { SystemComsTextBox } from "@/components/infoBoxes/SystemComsTextBox";


export const annoStorageKey = `${getTenant()}_annoExplorer`

const { File, PaintBucket, Funnel } = icons;

export const StyledGradientContainer = styled.div`
  width: 100%;
  height: 100%;
  overflow: hidden;
  padding: 1.2rem;
  border-radius: 1rem;
  display: flex;
  flex-direction: column;
  gap: 1rem;
  ${transition("height")}
  
  background: linear-gradient(
      135deg,
    #D9E6F2 0%,    /* Left blue shade */
    #D8E3F3 20%,   /* Middle-left blue shade */
    #ECE0F1 60%,   /* Middle-right purple shade */
    #F3DCF1 100%   /* Right pink/purple shade */
  );
`;



const ColorCodeBreakdown = ({
  colorCodeBanner,
  setColorCodeBanner,
  colorCodeOptions,
  activeColorFilter,
  changeColorFilter,
  activeColorConfig,
  updateColorConfig,
  annoExplorerConfigs,
  selectedTPLsArrayOptions,
  filterConfigs,
  hasNewTopicModelling,
  colorCodeFilters,
  setColorCodeFiltersSinglePick,
}) => {

  // Strip filter types/ids that color-code can't render (dates, author filters etc.).
  const colorCodeFilterConfigs = useMemo(
    () => cleanFilterConfigsForColorCode(filterConfigs),
    [filterConfigs]
  );

  return (
    <div style={{ position: "relative", display: "flex", gap: "1.4rem", flexDirection: "column" }}>
      <div style={{ padding: "1.4rem", paddingBottom: 0}}>
      {colorCodeBanner && (
        <SystemComsTextBox>
          <div>
            <UI_BODY_SM>
              <UI_BODY_BOLD_SM style={{ display: "inline-block", marginRight: "0.5rem" }}>Colorcode </UI_BODY_BOLD_SM>
              lets you breakdown your annotations and view them with different colors using tags from one tag category.
            </UI_BODY_SM>
          </div>
          <div style={{ display: "flex", justifyContent: "flex-end" }}>
            <ButtonPrimaryCompact onClick={() => setColorCodeBanner(false)}>Got it</ButtonPrimaryCompact>
          </div>
        </SystemComsTextBox>
      )}
      </div>
      {hasNewTopicModelling ? (
        // New filter-UI category picker — single-pick semantics enforced by
        // the wrapper passed in from the parent. Translation to the BE
        // colorbreakDownFilters happens at the parent level.
        <FilterModule
          usesAnnoFilters={true}
          filterConfig={colorCodeFilterConfigs}
          activeFilters={colorCodeFilters}
          setActiveFilters={setColorCodeFiltersSinglePick}
          usedIn={"annoExplorer_colorCode"}
          skipLocalFilterSave
          hideFilterModuleHeader
          hideIntraFilterOperatorSelect
          noAppliedValueChipsTruncation
          addFilterButtonText={colorCodeFilters.length > 0 ? "Change Breakdown" : "Add Breakdown"}
        />
      ) : (
        <>
          <div style={{ padding: "1.4rem", display: "flex", gap: "0.4rem", flexDirection: "column", width: "100%" }}>
            <UI_BODY_SM>Tag Category</UI_BODY_SM>
            {(colorCodeOptions.length > 0) ? (
              <DropdownSingle
                S
                matchSelectInputWidth
                popOutOfOverflowHiddenParent
                matchSelectInputWidth
                options={colorCodeOptions}
                onChange={(k, v) => {
                  changeColorFilter(v);
                }}
                value={activeColorFilter}
              />
            ) : (
              <UI_BODY_SEMIBOLD_SM>Not Supported for Indirect / ROLLUP filters</UI_BODY_SEMIBOLD_SM>
            )}
          </div>

          {(activeColorFilter && activeColorFilter?.source?.filterType) && (
            <div style={{ display: "flex", gap: "0.4rem", flexDirection: "column", width: "100%" }}>
              <UI_BODY_SM>Select the tags to view breakdown</UI_BODY_SM>
              <ColorCodeLightBox
                key={JSON.stringify(activeColorFilter)}
                activeColorFilter={activeColorFilter}
                contentTypes={selectedTPLsArrayOptions?.map(d => d.value)}
                value={activeColorConfig}
                onChange={(value) => updateColorConfig(value)}
              />
            </div>
          )}
        </>
      )}

      
    </div>
  );
};


const FiltersSidebar = ({
  isMobile,
  contentTypeSelectRef,
  filterConfigs,
  tplOptionsDropdownData,
  selectedTPLsArrayOptions,
  tplOptions,
  activeFilters,
  setActiveFilters,
  setSelectedTpls,
  handleTagClearClick,
  selectedTpls,
  handleTemplateSelection,
  areFiltersLoading
}) => {
  return (
    <>
      {!isMobile && (
        <div>
          <div style={{ padding: "1.4rem", position: "sticky", top: 0, paddingBottom: "0rem", display: "flex", alignItems: "center", gap: "0.3rem" }}>
            <File size={16} weight="bold"/> <UI_BODY_SEMIBOLD_SM>{"Datasets"}</UI_BODY_SEMIBOLD_SM>
          </div>
          <div style={{ padding: "1.4rem", display: "flex", gap: "0.4rem", flexDirection: "column" }}>
            <DropdownMulti
              S
              genCustomSelectComp={() => 
                <CustomSelectComp
                  placeholder={"Select Content Types"}
                  display={`${selectedTPLsArrayOptions?.length} Selected`}
                />
              }
              popOutOfOverflowHiddenParent={true}
              options={tplOptionsDropdownData}
              value={selectedTPLsArrayOptions}
              onChange={handleTemplateSelection}
            />
            {selectedTPLsArrayOptions?.length > 0 &&
              <div style={{ display: "flex", gap: "0.4rem", width: '100%', flexWrap: "wrap" }}>
                {selectedTPLsArrayOptions.map(v => (
                  <TagClear
                    key={v.value}
                    grey
                    id={v.value}
                    display={v.display}
                    size={'XS'}
                    onClick={() => handleTagClearClick(v.value)}
                  />
                ))}
              </div>
            }
          </div>
          <Divider />
        </div>
      )}
      <div style={{ height: `calc(100dvh - ${contentTypeSelectRef.current?.getBoundingClientRect()?.bottom}px)`}}>
        {areFiltersLoading ? (
          <FiltersLoader />
        ) : (
        <FilterModule
          usesAnnoFilters={true}
          key={filterConfigs.map(conf => conf.sectionId).join('__')}
          filterConfig={filterConfigs}
          contentTypes={selectedTPLsArrayOptions?.map(d => d.value)}
          activeFilters={activeFilters}
          setActiveFilters={setActiveFilters}
          usedIn={'Annotation Explorer'}
        />
        )}
      </div>
    </>
  );
};


export const AnnotationExplorer = () => {

   let {
      SELF_MANAGED_BASE_CONFIGS
    } = useGetQueryData("platformConfigs");

  const platformConfigs = useGetQueryData("platformConfigs");
  const hasNewTopicModelling = getAnnoMode(platformConfigs) !== "legacy";



  const screenWidth = useScreenWidth()  
  const isMobile = screenWidth < getBreakPoint("md");
  
  // Both side panels (lsb = filters, rsb = viz) start collapsed; the user opens
  // them from their toggles when needed.
  const [parentToggleState, setParentToggleState] = useState({ lsb: false, rsb: false });

  const headerHeight = useHeaderHeight();

  const annoExplorerConfigs = getAnnoExplorerConfigsForThisTenant()

  const [ csvExporting, setCsvExporting ] = useState(false);
  
  

  const {
    tplOptions,
    tplOptionsDropdownData,
    selectedTpls,
    setSelectedTpls,
    activeFilters,
    setActiveFilters,
    activeSort,
    setActiveSort,
    keyword,
    setKeyword,
    filterConfigs,
    areFiltersLoading,
    DEFAULT_SORT_OPTIONS,
    
    dataSource
    // data: data_,
    // dataFetchStatus,
    // error,
    // observerRef
  } = useGetAnnotationExplorerData({
    contentTypesWhitelist: annoExplorerConfigs?.contentTypes?.whitelist,
    initialCardsLimit: 20,
     dataSource:"annotations"
  })

  const flatFilterConfigs = useAutoGenFilterConfigsFromTpl({
    selectedTpls,
    disableHierarchyUI: true,
  });

  const colorCodeOptions = useMemo(() => {
    return generateColorCodeOptions(flatFilterConfigs)
  },[flatFilterConfigs])
  const [ breakDown, setBreakDown ] = useState(() => {
    if (typeof window !== 'undefined') {
      try {
        const savedValue = sessionStorage.getItem(annoStorageKey);
        if (savedValue) {
          return JSON.parse(savedValue);
        }
      } catch (error) {
        console.error('Error parsing saved color code state', error);
      }
    }
    return {
      activeColorFilter: colorCodeOptions[0]?.options[0],
      activeColorConfig: undefined
    };
  });

  const selectedTPLsArrayOptions = useMemo(() => {
    return selectedTpls.map((d) => ({
      display: d.general?.content?.title || d.kp_content_type,
      value: d.kp_content_type,
    }))
  }, [ selectedTpls, activeSort ])

  const contentTypeFilter = useMemo(() => ({
    "filterId": "contentTypeFilter_contentType",
    "values": selectedTPLsArrayOptions,
    "target": {
      "filterType": "valuePathType",
      "valuePath": "meta.contentType",
    },
  }), [selectedTPLsArrayOptions]);

  const allActiveFilters = useMemo(() => [
    contentTypeFilter,
    ...activeFilters,
  ], [contentTypeFilter, activeFilters]);

  const { activeColorFilter, activeColorConfig } =  useMemo(() => breakDown, [ breakDown ]) ;

  // New filter-UI based color-code state. Lives at this level so we can
  // translate it into the BE colorbreakDownFilters payload alongside the
  // legacy state below.
  const [colorCodeFilters, setColorCodeFilters] = useState([]);
  const setColorCodeFiltersSinglePick = useCallback((newFiltersOrUpdater) => {
    setColorCodeFilters((prev) => {
      const next = typeof newFiltersOrUpdater === "function" ? newFiltersOrUpdater(prev) : newFiltersOrUpdater;
      const LEVEL_BY_FILTER_ID = {
        [FILTER_IDS.themes]: "themes",
        [FILTER_IDS.subThemes]: "subThemes",
        [FILTER_IDS.tags]: "tags",
      };
      // Group activeFilters into a map keyed by `${filterId}::${bucketKey}` —
      // matches the block identity from groupAnnoFilters. Multi-selecting
      // values within a single bucket is still 1 filter; a new bucket means
      // 2 filters → drop the older bucket(s) and keep only the newest.
      const groupByBucket = (arr) => {
        const map = new Map();
        for (const f of arr || []) {
          for (const v of f?.values || []) {
            const level = LEVEL_BY_FILTER_ID[f.filterId];
            const bucketKey = level ? getAnnoFilterBucketKey(level, v) : null;
            const k = `${f.filterId}::${bucketKey}`;
            if (!map.has(k)) map.set(k, { source: f, values: [] });
            map.get(k).values.push(v);
          }
        }
        return map;
      };
      const nextBuckets = groupByBucket(next);

      // Helper: assign `badgeColor` to each filter's values by their order.
      // Same field name TagClearV2 reads via its `badgeColor` prop, so the
      // chip color and the BE colorbreakDownFilters payload share one source
      // of truth (translator maps badgeColor → BE's `fill` field).
      const withBadgeColors = (arr) =>
        (arr || []).map((f) => ({
          ...f,
          values: (f.values || [])
            .slice(0, MAX_COLOR_CODE_COLORS)
            .map((v, i) => ({ ...v, badgeColor: COLOR_CODE_COLORS[i % COLOR_CODE_COLORS.length] })),
        }));

      if (nextBuckets.size <= 1) return withBadgeColors(next);
      const prevBuckets = groupByBucket(prev);
      let newestKey = null;
      for (const k of nextBuckets.keys()) {
        if (!prevBuckets.has(k)) newestKey = k;
      }
      if (!newestKey) return withBadgeColors(next);
      const { source, values } = nextBuckets.get(newestKey);
      return withBadgeColors([{ filterId: source.filterId, target: source.target, values }]);
    });
  }, []);

  // BE payload for colorbreakDown — under non-legacy anno mode we translate the
  // new filter-UI state; otherwise we keep the legacy step1+step2 shape.
  const colorbreakDownFiltersPayload = useMemo(() => {
    if (hasNewTopicModelling) {
      return translateColorCodeFiltersToBE(colorCodeFilters);
    }
    return {
      ...(activeColorConfig || {}),
      ...(activeColorFilter ? { filterType: activeColorFilter.target.filterType } : {}),
    };
  }, [hasNewTopicModelling, colorCodeFilters, activeColorConfig, activeColorFilter]);

  const { 
    data, 
    fetchNextPage, 
    hasNextPage, 
    status: dataFetchStatus,
    error,
    isFetchingNextPage,
    colorBreakdownStats,
    // data, status, isRefetching, fetchNextPage, hasNextPage, isFetchingNextPage 
  } = useGetAnnotationsLazy({
    // tplFilters: selectedTPLsArrayOptions,
    activeFilters: allActiveFilters,
    dataSource ,
    searchConfig: {
      // type: "keyword",
      fields: ["annotations.fragment.allText", "contentEnhancedText"],
    },
    translationConfig: {
      customBlocks: [
        { comp: "TitleInput", props: {}, valuePath: "main.title" },
        {
          comp: "LexicalTextEditor",
          props: {},
          valuePath: "annotations.fragment",
        },
      ],
    },
    activeSort,
    searchTerm: keyword,
    colorbreakDownFilters: colorbreakDownFiltersPayload,
    // findQuery,
    limit: 20,
    ...(annoExplorerConfigs?.getDataConfig || {})
    // queryId: `document-${documentId}`
  });

  const {data: countData, status: countDataStatus} = useES_CountData({
    contentTypes: ['annotations'], //over here contenttypes maps directly to elastic search index name.
    enabled: dataFetchStatus === 'success' && !annoExplorerConfigs?.disableTotalCount,
    activeFilters: allActiveFilters
  })

  const { observerRef } = useElemInView({
    callback: fetchNextPage,
    enabled: !!hasNextPage && !isFetchingNextPage,
  });

  const contentTypeSelectRef = useRef(null);
  
  const { refetch: refetchCsvData } = useGetExportToCsvContent({
    
        exportAnnotation: true,
        activeFilters: allActiveFilters,
        searchTerm: keyword,
        dataSource: dataSource,
        colorbreakDownFilters: colorbreakDownFiltersPayload,
        batchSize:40,
        isBatchDownload:true
        // Add any other parameters needed for the export
      
    
  });

  const handleDownloadCsv = async () => {
    try {
      setCsvExporting(true);
      
      

      const { data: csvData } = await refetchCsvData();
      
      setCsvExporting(false);

      if (csvData) {
        downloadCsvFile({
          data: csvData,
          fileName: `annotations_export_${new Date().toISOString().split('T')[0]}.csv`,
        });
      }


    } catch (err) {
      console.error("CSV export error", err);
      setCsvExporting(false);
    }
  };

  const handleTagClearClick = (value) => {
    setSelectedTpls((prevSelectedTpls) =>
      prevSelectedTpls.filter((tpl) => tpl.kp_content_type !== value)
    );
  };

  const tabOptions = [
    { value: "filters", icon: "Funnel", display: isMobile ?  "TagFilter" : "Filters" },
    !annoExplorerConfigs?.disableColorCode ? { value: "breakdown", icon: "PaintBucket", display: "Color Code" } : null
  ].filter(Boolean);
  
  
  const [ selectedView, setSelectedView ] = useState(tabOptions[0])
  
  const [ colorCodeBanner, setColorCodeBanner ] = useState(true)
  // const [ enableColorCode, setEnableColorCode ] = useState( !!activeColorFilter )

  // const { data, colorsConfig: appliedColorConfig } = activeColorConfig ? addFillColorsToEachAnno({ data: data_?.pages?.flatMap(page => page.data) || [], colorsConfig: breakDown?.activeColorConfig }) : { data: data_ }

  useEffect(() => {
    if (typeof window !== 'undefined') {
      sessionStorage.setItem(annoStorageKey, JSON.stringify(breakDown));
    }
  }, [ breakDown , annoStorageKey ]);


  const changeColorFilter = (value) => {
    setBreakDown(prevState => {
      return {
        activeColorFilter: value,
        activeColorConfig: undefined 
      };
    });
    
  };

  const updateColorConfig = (value) => {
    setBreakDown(prevState => {
      return {
        ...prevState,
        activeColorConfig: value
      };
    });
  };
  
  
  useEffect(() => {
    const handleBeforeUnload = () => {
      if (typeof window !== 'undefined') {
        sessionStorage.setItem(annoStorageKey, JSON.stringify(breakDown));
      }
    };
  
    window.addEventListener('beforeunload', handleBeforeUnload);
    return () => {
      window.removeEventListener('beforeunload', handleBeforeUnload);
    };
  }, [ breakDown, annoStorageKey ]);


  // const enableColorCodeFn = (k, v) => {
  //   if (!v) {
  //     setBreakDown({
  //       activeColorFilter: undefined,
  //       activeColorConfig: undefined
  //     });
  //   }
  //   setEnableColorCode(v);
  // }; 

  const handleTemplateSelection = (k, v) => {
      // Convert v (new selection) to full template objects
   const newSelectedTpls = v.map((d) =>
     tplOptions.find((dd) => dd.kp_content_type === d.value)
   );

   // Find additions: items in newSelectedTpls but not in selectedTpls
   const additions = newSelectedTpls.filter(newTpl => 
     !selectedTpls.some(currentTpl => currentTpl.kp_content_type === newTpl.kp_content_type)
   );

   // Find subtractions: items in selectedTpls but not in newSelectedTpls
   const subtractions = selectedTpls.filter(currentTpl => 
     !newSelectedTpls.some(newTpl => newTpl.kp_content_type === currentTpl.kp_content_type)
   );

   // Track the changes
   if(additions.length > 0){
     mixpanel.track('Content Template Selected', {
       Selected: additions.map(d => d.general?.content?.title || d.kp_content_type).join(', '),
       Feature: 'Annotation Explorer'
     });
   }

   if(subtractions.length > 0){
     mixpanel.track('Content Template Deselected', {
       Deselected: subtractions.map(d => d.general?.content?.title || d.kp_content_type).join(', '),
       Feature: 'Annotation Explorer'
     });
   }

   // Update state
   setSelectedTpls(newSelectedTpls);
  }
  
  const {parentWrapperRef, gridHeightCSS} = useDynamicLayoutHeight()
  const getFlattenedData = data => data?.pages?.flatMap(page => page.data)
  return (

    <div ref={parentWrapperRef}>

      <SidebarLayoutV2
        
        gridHeightCSS={gridHeightCSS}
        toggleAnimationStyle="slide"
        contentSectionMinWidth="400px"

        toggleState={parentToggleState}
        setToggleState={setParentToggleState}
        
        lsbAllowCollapse={true}
        lsbAllowResize={!isMobile}
        lsbShowToggleOnlyWhenClosed={!isMobile}
        lsbWidth={isMobile ? screenWidth + 10 : 300}
        lsbComp={
          <div style={{ position: "relative" }}>
            {!isMobile && <div style={{ position: "sticky", top: 0, zIndex: 1000, background: "white" }}>
              <div style={{ display: "flex", alignItems: "center" }}>
                <div style={{ flex: 1, minWidth: 0 }}>
                  <TabBarStyle2
                      options={tabOptions}
                      value={selectedView}
                      onChange={(id, v) => {
                        setSelectedView(v)
                        mixpanel.track('Analysis Type Tab Switched', {
                          'Tab Name': v.display,
                          Feature: 'Annotation Explorer'
                        })
                      }}
                      style={{ padding: "0.45rem 1rem", maxHeight: "4rem" }}
                      />
                </div>
                <ButtonGhostV2
                  icon="CaretLeft"
                  style={{ marginRight: "0.4rem" }}
                  onClick={() => setParentToggleState(prev => ({ ...prev, lsb: false }))}
                />
              </div>
              <Divider/>
            </div> }
            {isMobile &&
            <div style={{ position: "Sticky", top: 0, zIndex: 99, background: "white" }}> 
              <div style={{ display: "flex", height: "4.4rem", alignItems: "center", justifyContent: 'space-between', padding: "0.45rem 1.4rem" }}>
                <div style={{ display: "flex", gap: "0.4rem" }}>
                    <UI_BODY_BOLD_SM>{selectedView.display}</UI_BODY_BOLD_SM>
                </div>  
                <ButtonSecondaryCompact onClick={() => setParentToggleState(prev => ({ ...prev, lsb: !prev.lsb }))}>Close</ButtonSecondaryCompact>
              </div>
              <Divider />
            </div>  }
            {
              selectedView?.value !== "breakdown" ?
              <FiltersSidebar
              isMobile={isMobile}
                contentTypeSelectRef={contentTypeSelectRef}
                filterConfigs={filterConfigs}
                tplOptionsDropdownData={tplOptionsDropdownData}
                selectedTPLsArrayOptions={selectedTPLsArrayOptions}
                tplOptions={tplOptions}
                activeFilters={activeFilters}
                setActiveFilters={setActiveFilters}
                setSelectedTpls={setSelectedTpls}
                handleTagClearClick={handleTagClearClick}
                selectedTpls={selectedTpls}
                handleTemplateSelection={handleTemplateSelection}
                areFiltersLoading={areFiltersLoading}
                />
                : <ColorCodeBreakdown
                {...{
                  colorCodeBanner,
                  setColorCodeBanner,
                  colorCodeOptions,
                  activeColorFilter,
                  changeColorFilter,
                  activeColorConfig,
                  updateColorConfig,
                  annoExplorerConfigs,
                  selectedTPLsArrayOptions,
                  filterConfigs,
                  hasNewTopicModelling,
                  colorCodeFilters,
                  setColorCodeFiltersSinglePick,
                }}
                />
            }
          </div>
        }

        {...(hasNewTopicModelling
          ? {
              rsbAllowCollapse: true,
              rsbAllowResize: true,
              rsbShowToggleOnlyWhenClosed: true,
              rsbWidth: 350,
              rsbComp: (
                <AnnotationExplorerVizPanel
                  queryActiveFilters={allActiveFilters}
                  activeFilters={activeFilters}
                  setActiveFilters={setActiveFilters}
                  filterConfigs={filterConfigs}
                  colorCodeFilters={colorCodeFilters}
                  setColorCodeFiltersSinglePick={setColorCodeFiltersSinglePick}
                  onClose={() =>
                    setParentToggleState((prev) => ({ ...prev, rsb: !prev.rsb }))
                  }
                />
              ),
            }
          : {})}
      >
      <div style={{ position: "relative" }}>

        {getFlattenedData(data)?.length > 0 && <SearchSortPanel 
          {...{ 
            tplOptionsDropdownData, 
            selectedTPLsArrayOptions, 
            setSelectedTpls, 
            selectedView, 
            tplOptions, 
            selectedView, 
            setSelectedView, 
            setParentToggleState, 
            isMobile, 
            setKeyword, 
            keyword, 
            defaultSortOptions: DEFAULT_SORT_OPTIONS, 
            activeSort, 
            setActiveSort,
            disableColorCode: annoExplorerConfigs?.disableColorCode,
            handleTemplateSelection
          }}/>}

        <ListingModuleAnnotationExplorer
          observerRef={hasNextPage ? observerRef : null}
          dataFetchStatus={dataFetchStatus}
          dataFetchError={error}
          isFetchingNextPage={isFetchingNextPage}
          data={getFlattenedData(data)}
          countData={countData}
          countDataStatus={countDataStatus}
          breakDown={breakDown} 
          setBreakDown={setBreakDown}
          colorBreakdownStats={data?.pages[0]?.colorBreakdownStats}
          activeColorFilter={activeColorFilter}
          isMobile={isMobile} 
          selectedTPLsArrayOptions={selectedTPLsArrayOptions}
          csvExporting={csvExporting}
          handleDownloadCsv={handleDownloadCsv} 
          activeFilters={allActiveFilters}
          dataSource={dataSource}
          searchTerm={keyword}
          defaultSortOptions={DEFAULT_SORT_OPTIONS}
          activeSort={activeSort}
          setActiveSort={setActiveSort}
          />
      </div>
      </SidebarLayoutV2>
      </div>

  );
};

